import React, { useEffect, useRef, useState } from "react";
import ReactQuill from "react-quill"; // Import React Quill
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate } from "react-router-dom";
import { useDataLayerValue } from "../../DataLayer/DataLayer";

import moment from "moment-timezone";
import { getMyZone } from "../../constants/getTimeDate";
import DateAndTimePicker from "../DateAndTimePicker";
import { constants } from "../../constants/constants";
import LocationAndExpcept from "../../constants/LocationAndExpcept";
import { uploadFile } from "../../utils/ApiCalls/Document";
import {
  createExperience,
  getExperienceDataLocation,
  updateExperienceData,
  cleanupExperienceImages,
} from "../../utils/ApiCalls/Experience";
import { getAllLocations } from "../../utils/ApiCalls/Locations";
import { addlog } from "../../utils/ApiCalls/Logs";
import { checkFields } from "../../utils/Validation/checkFields";

import Swal from "sweetalert2";
import { IMAGE_SUB_TYPE, IMAGE_TYPE } from "../../constants/ImageConstant";
import UploadFileImageBanner2 from "../Banner/uploadFileImageBanner copy";
import AltTextInput, { pickAltText } from "../AltTextInput/AltTextInput";

const EXPERIENCE_ALT_FIELDS = [
  "image_alt",
  "simplified_chinese_image_alt",
  "traditional_chinese_image_alt",
  "bahasa_image_alt",
];

const ExperienceInputs = ({ experience }) => {
  const [englishTitle, setEnglishTitle] = useState(
    experience?.englishTitle || ""
  );

  const [description, setDescription] = useState(experience?.description || "");
  const [description2, setDescription2] = useState(
    experience?.description || ""
  );
  const [simplifiedChineseTitle, setSimplifiedChineseTitle] = useState(
    experience?.simplifiedChineseTitle || ""
  );
  const [traditionalChineseTitle, setTraditionalChineseTitle] = useState(
    experience?.traditionalChineseTitle || ""
  );

  const [simplifiedChineseDescription, setSimplifiedChineseDescription] =
    useState("");

  const [traditionalChineseDescription, setTraditionalChineseDescription] =
    useState("");
  const [simplifiedChineseDescription2, setSimplifiedChineseDescription2] =
    useState("");
  const [traditionalChineseDescription2, setTraditionalChineseDescription2] =
    useState("");

  const [image, setImage] = useState(null);
  const [isActive, setIsActive] = useState(true);
  const [isDateEdit, setIsDateEdit] = useState(false);
  const originalValidDates = useRef({ valid_from: "", valid_to: "" });
  const [selectedFile, setSelectedFile] = useState(null);
  const [traditionalChineseFile, setTraditionalChineseFile] = useState(null);
  const [simplifiedChineseFile, setSimplifiedChineseFile] = useState(null);
  const [title, setTitle] = useState(experience?.title || "");
  const [displayLocation, setDisplayLocation] = useState([]);
  const [url, setUrl] = useState(experience?.url || "");
  const [traditional_chinese_image, setTraditional_chinese_image] =
    useState(null);
  const [simplified_chinese_image, setSimplified_chinese_image] =
    useState(null);

  const [bahasaTitle, setBahasaTitle] = useState("");
  const [altText, setAltText] = useState({});
  const [bahasaDescription, setBahasaDescription] = useState("");
  const [bahasaDescription2, setBahasaDescription2] = useState("");
  const [bahasaFile, setBahasaFile] = useState(null);
  const [valid_from, setValidFrom] = useState();
  const [valid_to, setValidTo] = useState();
  const [locationOption, setLocationOption] = useState([]);
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [error, setError] = useState();
  const navigate = useNavigate();
  const [currentLocation, setCurrentLocation] = useState([]);
  useEffect(() => {
    if (!experience?.id) setIsDateEdit(true);
    if (experience) {
      if (experience.image) {
        getLocationData();
      }
      setImage(experience?.image);
      setTraditional_chinese_image(experience?.traditional_chinese_image);
      setSimplified_chinese_image(experience?.simplified_chinese_image);

      setTitle(experience?.title);
      setDescription(experience?.description);
      setDescription2(experience?.description2);
      setSimplifiedChineseTitle(experience?.simplified_chinese_title);
      setTraditionalChineseTitle(experience?.traditional_chinese_title);
      setEnglishTitle(experience?.english_title);
      setUrl(experience?.url);
      setAltText(pickAltText(experience, EXPERIENCE_ALT_FIELDS));
      setSimplifiedChineseDescription(
        experience?.simplified_chinese_description
      );
      setTraditionalChineseDescription(
        experience?.traditional_chinese_description
      );
      setSimplifiedChineseDescription2(
        experience?.simplified_chinese_description2
      );
      setTraditionalChineseDescription2(
        experience?.traditional_chinese_description2
      );
      setBahasaTitle(experience?.bahasa_title || "");
      setBahasaDescription(experience?.bahasa_description || "");
      setBahasaDescription2(experience?.bahasa_description2 || "");
      if (experience.location_id) setDisplayLocation([experience.location_id]);
      if (experience?.is_active !== undefined) setIsActive(experience.is_active === 1);
    }
  }, [experience]);

  useEffect(() => {
    if (experience && locationOption.length > 0) {
      const tz = locationOption.find(l => l.id == experience.location_id)?.timezone || "Asia/Kuala_Lumpur";
      const initialValidFrom = experience?.valid_from ? moment.utc(experience.valid_from).tz(tz).format("YYYY-MM-DDTHH:mm:ss") : "";
      const initialValidTo = experience?.valid_to ? moment.utc(experience.valid_to).tz(tz).format("YYYY-MM-DDTHH:mm:ss") : "";
      setValidFrom(initialValidFrom);
      setValidTo(initialValidTo);
      originalValidDates.current = { valid_from: initialValidFrom, valid_to: initialValidTo };
      if (experience?.id) setIsDateEdit(false);
    }
  }, [experience, locationOption]);
  const getLocationData = async () => {
    let data = await getExperienceDataLocation({ image: experience.image });

    if (data.error) {
      // dispatch({
      //   type: "SET_ERROR_MESSAGE",
      //   errMess: { message: data.error, type: "error" },
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else {
      setCurrentLocation(data);
      setDisplayLocation(data?.map((item) => item.location_id) || []);
    }
  };

  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
      [{ direction: "rtl" }],
    ],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "link",
    "image",
  ];

  const handleEnglishTitleChange = (content) => {
    setEnglishTitle(content);
  };

  const handleSimplifiedChineseTitleChange = (content) => {
    setSimplifiedChineseTitle(content);
  };

  const handleTraditionalChineseTitleChange = (content) => {
    setTraditionalChineseTitle(content);
  };

  const handleCheckboxChange = () => {
    try {
      if (new Date(valid_to) < new Date()) {
        throw new Error(`Experience is expired`);
      }
      setIsActive(!isActive);
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: e.message,
      });
    }
  };
  const handleFileChange = (event) => {
    // Handle file change logic if needed
    setSelectedFile(event.target.files[0]);
  };

  const handleRemoveImage = () => {
    // Handle removing image logic if needed
    setSelectedFile(null);
  };
  const handleDisplayLocationChange = (selectedOptions) => {
    setDisplayLocation(selectedOptions);
  };
  useEffect(() => {
    getOptionLocation();
  }, []);

  const getOptionLocation = async () => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getAllLocations();
    
    if (data.error) {
      // dispatch({
      //   type: "SET_ERROR_MESSAGE",
      //   errMess: { message: data.error, type: "error" },
      // });
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: data.error,
      });
    } else {
      setLocationOption(data?.data || []);
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const addExperience = async (e) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    e.preventDefault();
    let added = false;
    let dataValues = {
      image,
      simplified_chinese_image,
      traditional_chinese_image,
      title,
      url,
      description,
      order_by: 1,
      description2,
      is_active: isActive ? 1 : 0,
      english_title: englishTitle,
      valid_from: valid_from,
      valid_to: valid_to,
      isDateEdit,
      ...altText,
      simplified_chinese_title: simplifiedChineseTitle,
      traditional_chinese_title: traditionalChineseTitle,
      simplified_chinese_description: simplifiedChineseDescription,
      simplified_chinese_description2: simplifiedChineseDescription2,
      traditional_chinese_description: traditionalChineseDescription,
      traditional_chinese_description2: traditionalChineseDescription2,
      bahasa_title: bahasaTitle,
      bahasa_description: bahasaDescription,
      bahasa_description2: bahasaDescription2,
    };
    if (selectedFile) {
      if (typeof selectedFile === "string") {
        dataValues.image = selectedFile.replace(constants.MEDIAURL + "/", "");
      } else {
        let imageType = {
          type: IMAGE_TYPE.DEAL_IMG,
          subType: IMAGE_SUB_TYPE.ENGLISH_IMG,
        };
        let image = await uploadFile(selectedFile, undefined, undefined, typeof experience?.image === 'string' ? experience.image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image?.error) throw new Error(image.error);

        dataValues.image = image?.url;
      }
    } else {
      dataValues.image = "";
    }
    if (traditionalChineseFile) {
      if (typeof traditionalChineseFile === "string") {
        dataValues.traditional_chinese_image = traditionalChineseFile.replace(
          constants.MEDIAURL + "/",
          ""
        );
      } else {
        let imageType = {
          type: IMAGE_TYPE.DEAL_IMG,
          subType: IMAGE_SUB_TYPE.TRADITIONAL_CHINESE_IMG,
        };
        let image = await uploadFile(traditionalChineseFile, undefined, undefined, typeof experience?.traditional_chinese_image === 'string' ? experience.traditional_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image?.error) throw new Error(image.error);

        dataValues.traditional_chinese_image = image?.url;
      }
    } else {
      dataValues.traditional_chinese_image = "";
    }
    if (simplifiedChineseFile) {
      if (typeof simplifiedChineseFile === "string") {
        dataValues.simplified_chinese_image = simplifiedChineseFile.replace(
          constants.MEDIAURL + "/",
          ""
        );
      } else {
        let imageType = {
          type: IMAGE_TYPE.DEAL_IMG,
          subType: IMAGE_SUB_TYPE.TRADITIONAL_CHINESE_IMG,
        };
        let image = await uploadFile(simplifiedChineseFile, undefined, undefined, typeof experience?.simplified_chinese_image === 'string' ? experience.simplified_chinese_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image?.error) throw new Error(image.error);

        dataValues.simplified_chinese_image = image?.url;
      }
    } else {
      dataValues.simplified_chinese_image = "";
    }
    if (bahasaFile) {
      if (typeof bahasaFile === "string") {
        dataValues.bahasa_image = bahasaFile.replace(constants.MEDIAURL + "/", "");
      } else {
        let imageType = {
          type: IMAGE_TYPE.DEAL_IMG,
          subType: IMAGE_SUB_TYPE.BAHASA_IMG,
        };
        let image = await uploadFile(bahasaFile, imageType, undefined, typeof experience?.bahasa_image === 'string' ? experience.bahasa_image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "") : null);
        if (image?.error) throw new Error(image.error);
        dataValues.bahasa_image = image?.url;
      }
    } else {
      dataValues.bahasa_image = "";
    }

    let valid = checkFields(dataValues, "experiences", "");
    if (valid) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: valid,
      });
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
    } else {
      try {
        // Compute, from the whole group's current state, which old image
        // files this save will orphan — an old value held by any location
        // in the group that won't match the new value being applied
        // everywhere. Sent once to the backend after all the location
        // saves below finish, so it doesn't depend on their ordering.
        const EXPERIENCE_IMAGE_FIELDS = ["image", "arabic_image", "bahasa_image", "simplified_chinese_image", "traditional_chinese_image"];
        const oldImageValues = new Set();
        currentLocation.forEach((item) => {
          EXPERIENCE_IMAGE_FIELDS.forEach((field) => {
            if (item[field]) oldImageValues.add(item[field]);
          });
        });
        const imagesToDelete = Array.from(oldImageValues).filter(
          (file) => !EXPERIENCE_IMAGE_FIELDS.some((field) => dataValues[field] === file)
        );

        await Promise.all(
          displayLocation.map(async (item, index) => {
            const locTimezone = locationOption.find(i => i.id == item)?.timezone || "Asia/Kuala_Lumpur";
            let values = {
              location_id: item,
              ...dataValues,
              valid_from: valid_from ? moment.tz(valid_from, locTimezone).utc().format("YYYY-MM-DDTHH:mm:ss") : valid_from,
              valid_to: valid_to ? moment.tz(valid_to, locTimezone).utc().format("YYYY-MM-DDTHH:mm:ss") : valid_to,
            };
            let data;
            if (experience?.id) {
              let locationValue = currentLocation.filter(
                (data) => data.location_id === item
              );
              if (locationValue.length > 0) {
                let { ...rest } = values;
                if (item === experience.location_id) {
                  data = await updateExperienceData(
                    locationValue[0].id,
                    values
                  );
                } else {
                  data = await updateExperienceData(locationValue[0].id, rest);
                }
              } else {
                await createExperience({
                  ...values,
                  recordIteration: index + 1,
                });
              }
            } else {
              values = {
                ...values,
                recordIteration: index + 1,
              };
              data = await createExperience(values);
            }

            
            if (data?.error) {
              throw new Error(data.error);
            } else {
              if (experience?.id) {
                addlog(
                  "Experience Updated",
                  "Experience",
                  {
                    id: experience.id,
                    title: values.title || experience.title,
                    url: url || experience.url,
                    location_id: experience.location_id,
                  },
                  userDetails.id
                );
              } else {
                addlog(
                  "Experience Created",
                  "Experience",
                  {
                    id: data.id,
                    title: values.title,
                    url: values.url,
                    location_id: item,
                  },
                  userDetails.id
                );
              }
            }
          })
        );

        await cleanupExperienceImages(imagesToDelete);

        dispatch({
          type: "SET_LOADING",
          loading: false,
        });

        if (!experience.id) {
          navigate("/website/cms/homepage/experience");
        } else {
          navigate("/website/cms/homepage/experience");
          dispatch({
            type: "SET_ERROR_MESSAGE",
            errMess: { message: "Values updated", type: "success" },
          });
        }
      } catch (error) {
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        // dispatch({
        //   type: "SET_ERROR_MESSAGE",
        //   errMess: {
        //     message: error.message || "Unknown error occurred",
        //     type: "error",
        //   },
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message || "Unknown error occurred",
        });
      }
    }
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addExperience}>
              <div className="card-body">
                <div className="row">
                  <div className="col-lg-12 ">
                    <LocationAndExpcept
                      displayLocation={displayLocation}
                      banner={experience}
                      locationOption={locationOption}
                      nondisplay
                      options={locationOption}
                      setDisplayLocation={setDisplayLocation}
                      handleDisplayLocationChange={handleDisplayLocationChange}
                    />
                  </div>
                  <UploadFileImageBanner2
                    mediaType={"image"}
                    className="col-lg-3"
                    width={389}
                    height={548}
                    image={
                      experience?.image
                        ? `${constants.MEDIAURL}/${experience?.image}`
                        : experience?.image
                    }
                    label={"English Experience Image"}
                    placeholder={"Upload experience Image"}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                  />
                  <UploadFileImageBanner2
                    mediaType={"image"}
                    className="col-lg-3"
                    // mandatory={displayLocation.find(location=>locationOption.find(l=> l.id===location)?.location_code === "CN") ? "*": ""}

                    width={389}
                    height={548}
                    image={
                      experience?.simplified_chinese_image
                        ? `${constants.MEDIAURL}/${experience?.simplified_chinese_image}`
                        : experience?.simplified_chinese_image
                    }
                    label={"Simplified Chinese Experience Image "}
                    placeholder={"Upload Simplified Chinese Experience Image"}
                    selectedFile={simplifiedChineseFile}
                    setSelectedFile={setSimplifiedChineseFile}
                  />
                  <UploadFileImageBanner2
                    mediaType={"image"}
                    className="col-lg-3"
                    // mandatory={displayLocation.find(location=>locationOption.find(l=> l.id===location)?.location_code === "CN") ? "*": ""}

                    width={389}
                    height={548}
                    image={
                      experience?.traditional_chinese_image
                        ? `${constants.MEDIAURL}/${experience?.traditional_chinese_image}`
                        : experience?.traditional_chinese_image
                    }
                    label={"Traditional Chinese Experience Image"}
                    placeholder={"Upload Traditional Chinese Experience Image"}
                    selectedFile={traditionalChineseFile}
                    setSelectedFile={setTraditionalChineseFile}
                  />

                  <UploadFileImageBanner2
                    mediaType={"image"}
                    className="col-lg-3"
                    width={389}
                    height={548}
                    image={
                      experience?.bahasa_image
                        ? `${constants.MEDIAURL}/${experience?.bahasa_image}`
                        : experience?.bahasa_image
                    }
                    label={"Bahasa Experience Image"}
                    placeholder={"Upload Bahasa Experience Image"}
                    selectedFile={bahasaFile}
                    setSelectedFile={setBahasaFile}
                  />
                  <AltTextInput className="col-lg-3" label="English Experience Image Alt Text" field="image_alt" values={altText} setValues={setAltText} />
                  <AltTextInput className="col-lg-3" label="Simplified Chinese Experience Image Alt Text" field="simplified_chinese_image_alt" values={altText} setValues={setAltText} />
                  <AltTextInput className="col-lg-3" label="Traditional Chinese Experience Image Alt Text" field="traditional_chinese_image_alt" values={altText} setValues={setAltText} />
                  <AltTextInput className="col-lg-3" label="Bahasa Experience Image Alt Text" field="bahasa_image_alt" values={altText} setValues={setAltText} />

                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">English Title</label>
                      <ReactQuill
                        value={englishTitle}
                        onChange={handleEnglishTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Simplified Chinese Title
                      </label>
                      <ReactQuill
                        value={simplifiedChineseTitle}
                        onChange={handleSimplifiedChineseTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Title
                      </label>
                      <ReactQuill
                        value={traditionalChineseTitle}
                        onChange={handleTraditionalChineseTitleChange}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Title</label>
                      <ReactQuill
                        value={bahasaTitle}
                        onChange={setBahasaTitle}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">English Description2</label>
                      <ReactQuill
                        value={description}
                        onChange={setDescription}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Simplified Chinese Description2
                      </label>
                      <ReactQuill
                        value={simplifiedChineseDescription}
                        onChange={setSimplifiedChineseDescription}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Description2
                      </label>
                      <ReactQuill
                        value={traditionalChineseDescription}
                        onChange={setTraditionalChineseDescription}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Description2</label>
                      <ReactQuill
                        value={bahasaDescription}
                        onChange={setBahasaDescription}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">English Description1</label>
                      <ReactQuill
                        value={description2}
                        onChange={setDescription2}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Simplified Chinese Description1
                      </label>
                      <ReactQuill
                        value={simplifiedChineseDescription2}
                        onChange={setSimplifiedChineseDescription2}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">
                        Traditional Chinese Description1
                      </label>
                      <ReactQuill
                        value={traditionalChineseDescription2}
                        onChange={setTraditionalChineseDescription2}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="fieldrow">
                      <label className="f_label">Bahasa Description1</label>
                      <ReactQuill
                        value={bahasaDescription2}
                        onChange={setBahasaDescription2}
                        modules={modules}
                        formats={formats}
                      />
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Url</label>
                      <input
                        className="f_input"
                        // required
                        type="text"
                        value={url}
                        onChange={(e) => setUrl(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-6 col-sm-6 col-6">
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="fieldrow">
                          <label className="f_label">
                            {" "}
                            Valid From <span style={{ color: "red" }}> *</span>
                          </label>
                          <DateAndTimePicker
                            value={valid_from}
                            min={moment(new Date()).format("YYYY-MM-DD")}
                            setValue={(e) => {
                              const val = e ? (e?.format ? e.format("YYYY-MM-DDTHH:mm:ss") : e) : "";
                              setValidFrom(val);
                              setValidTo("");
                              setIsDateEdit(
                                val !== originalValidDates.current.valid_from ||
                                "" !== originalValidDates.current.valid_to
                              );
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="fieldrow">
                          <label className="f_label">
                            Valid To <span style={{ color: "red" }}> *</span>
                          </label>
                          <DateAndTimePicker
                            value={valid_to}
                            min={valid_from ? moment(valid_from).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD")}
                            disabled={!valid_from}
                            setValue={(e) => {
                              const val = e ? (e?.format ? e.format("YYYY-MM-DDTHH:mm:ss") : e) : "";
                              setValidTo(val);
                              setIsDateEdit(
                                valid_from !== originalValidDates.current.valid_from ||
                                val !== originalValidDates.current.valid_to
                              );
                            }}
                          />
                        </div>
                      </div>
                    </div>
                    {displayLocation.length > 0 && (
                      <p style={{ marginTop: "8px", fontSize: "13px", color: "#666" }}>
                        {displayLocation.length === 1
                          ? `* Dates will be saved in ${locationOption.find(i => i.id == displayLocation[0])?.location_name} timezone (${locationOption.find(i => i.id == displayLocation[0])?.timezone}). Your timezone is ${getMyZone()}`
                          : `* Dates will be saved in each location's own timezone and converted to UTC. Your timezone is ${getMyZone()}`}
                      </p>
                    )}
                  </div>
                  <div className="col-12">
                    <div className="iti_inner">
                      <div className="icheck-primary d-inline">
                        <input
                          type="checkbox"
                          id="customCheckbox4"
                          name="r10"
                          checked={isActive}
                          onChange={handleCheckboxChange}
                        />
                        <label htmlFor="customCheckbox4">
                          {isActive ? (
                            <p>
                              <span style={{ fontWeight: 600 }}>Active</span>
                            </p>
                          ) : (
                            <p>
                              <span style={{ fontWeight: 200 }}>Active</span>
                            </p>
                          )}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {experience.id ? "Update" : "Add"} experience
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default ExperienceInputs;
